import { createRoute } from "@tanstack/react-router";
import { useSession } from "@/auth/client";
import { OpsScorecardPage } from "@/components/ops/ops-scorecard-page";
import { useDashboardGrants } from "@/components/ops/use-dashboard-grants";
import { TeamRosterPage } from "@/components/teams/team-roster-page";
import { Route as authenticatedRoute } from "../_authenticated";

const members = [
  {
    name: "Jacob Blair",
    title: "FPM Director",
    ownerId: "3c0f82bb-7ad3-42b3-b26e-856623052748",
    image: "/assets/headshots/jacob-blair.png",
  },
];

export const Route = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/teams/fpm",
  component: LeadershipTeamPage,
});

function LeadershipTeamPage() {
  const { data: session } = useSession();
  const isAdmin = (session?.user as { role?: string } | undefined)?.role === "admin";
  const grants = useDashboardGrants(!isAdmin);
  const canViewKpis = isAdmin || (grants?.includes("manufacturing") ?? false);

  return (
    <TeamRosterPage team="Leadership Team" members={members}>
      {canViewKpis && (
        <OpsScorecardPage
          dashboard="manufacturing"
          title="Manufacturing KPIs"
          description="FPM quarterly scorecard — capacity, on-time delivery, repair rate, first pass yield"
          embedded
        />
      )}
    </TeamRosterPage>
  );
}
